import store from "./store";
import { ADD_TO_WISH_LIST } from "../Pages/wishListPage/store/actionTypes";
import apiSettings from "../utils/apiSettings";
import { getCookie } from "../utils/cookies";

const checkFavourInLocalStorage = () => {
  if (!getCookie("favour")) return {};
  return JSON.parse(getCookie("favour"));
};
const getRootAttributes = () => {
  const root = document.getElementById("js-fs-search");

  return {
    ...root.dataset,
    facets: root.dataset.searchFacets.split("|").reduce((acc, c) => ({ ...acc, [c]: [] }), {}),
    query_args: {
      post_type: root.dataset.searchPostType,
      posts_per_page: root.dataset.searchPerPage,
      lang: root.dataset.searchLanguage,
      paged: 1,
      order: root.dataset.searchOrder,
      orderby: root.dataset.searchOrderby,
      value: root.dataset.searchValue,
    },
  };
};

const setInitAppSettings = () => {
  const settings = getRootAttributes();
  apiSettings.initAPI(settings);
  store.dispatch({
    type: "[SYSTEM] BASE API SETTINGS",
    payload: settings,
  });
  store.dispatch({
    type: ADD_TO_WISH_LIST,
    payload: checkFavourInLocalStorage(),
  });
};

export default setInitAppSettings;
